import { WidgetSchema } from 'features/views/LayoutEditor/types'

import { LinkBlocksWidget } from './LinkBlocksWidget'
import { LinkBlocksWidgetAdminControls } from './LinkBlocksWidgetAdminControls'
import { LinkBlocksWidgetLinkTargetField, LinkBlocksWidgetType } from './types'

export const LinkBlocksWidgetMeta: WidgetSchema<LinkBlocksWidgetType> = {
    category: 'data',
    label: 'Link blocks',
    icon: 'Link',
    component: LinkBlocksWidget,
    adminControlsComponent: LinkBlocksWidgetAdminControls,
    defaultAttrs: {
        style: 'regular',
        size: 'regular',
        links: [],
    },
    requireFields: (attrs) => {
        const requiredFields = new Set<string>()

        for (const link of attrs.links) {
            if (link.link?.type === 'field') {
                const fieldApiName = (link.link as LinkBlocksWidgetLinkTargetField).fieldApiName
                if (!!fieldApiName) {
                    requiredFields.add(fieldApiName)
                }
            }
        }

        return Array.from(requiredFields)
    },
}
